export default "__VITE_PUBLIC_ASSET__3a55c690__"